/*
 * @Description: 文件上传 配置
 * @Author: luozhao
 * @Date: 2021-04-20 14:50:20
 */

/**
 * 腾讯云sdk 桶配置文件
 */
export const bucketConfig = {
  khfw: {
    appName: '课后服务-正式',
    appId: '082c50cf71774b53bd4f7b5c23aa2ff3',
    sourceBucket: 'khfw-source-1256736654'
  }
};
